import { useRef, useEffect } from 'react';

export default function useInterval( callback, delay ) {
    const callbacRef = useRef();

    useEffect( () => {
        callbacRef.current = callback;
    } );

    useEffect( () => {
        if ( !delay ) {
            return () => { };
        }

        const interval = setInterval( () => {
            callbacRef.current && callbacRef.current();
        }, delay );
        return () => clearInterval( interval );
    }, [ delay ] );
}